export default __webpack_public_path__ + "static/list_widget-6604754a3983db6f0abdc19c5362e16b.webp";